import { useMutation, useQueryClient } from "@tanstack/react-query"
import { api } from "@/lib/api"
import { emailTemplateToDto, EmailTemplateDtoSchema, emailTemplateFromDto } from "@/models/email-template"
import type { EmailTemplate } from "@/models/email-template"

export function useUpdateEmailTemplate({ onSuccess }: { onSuccess?: () => void } = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (template: EmailTemplate) => {
      const dto = emailTemplateToDto(template)
      const response = await api.put("/api/email-templates", dto, EmailTemplateDtoSchema)
      return emailTemplateFromDto(response)
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["email-templates"] })
      queryClient.invalidateQueries({ queryKey: ["email-templates", variables.id] })
      if (onSuccess) onSuccess()
    },
    onError: (error) => {
      console.error("Error updating email template:", error)
    },
  })
}
